import React, { createContext, useState, useContext } from 'react';
import { Modal, Box, Button, Typography, Stack } from '@mui/material';
import { get } from '../utility/fetchWeb';
import VideoCalling from "../components/layouts/VideoCalling"; // Adjust the import path as necessary
import AudioCall from '../components/layouts/AudioCall';

const IncomingCallContext = createContext();

export const IncomingCallProvider = ({ children }) => {
  const [incomingCall, setIncomingCall] = useState(false);
  const [isCallActive, setIsCallActive] = useState(false); // Track if the call is active
  const [callConfig, setCallConfig] = useState(null); // Store Agora config for the call
  const [type, setType] = useState(""); // Default to video, can be changed based on incoming call details

  const showIncomingCall = (callDetails) => {
    setIncomingCall(callDetails);
    modeCheck(callDetails)

  };

  const getAgoraDetails = async () => {
    // This function can be simplified, as you fetch details right before the call
    // Ensure you have a valid channel name and UID before calling
    try {
      const res = await get(`/posts/generate-new-token?channelName=${incomingCall.channel || 'call'}&uid=${sessionStorage.getItem("userId") || 0}`);
      if (res && res.token) {

        setCallConfig(prev => ({
          ...prev,
          appId: res.appId || process.env.REACT_APP_AGORA_KEY,
          channelName: res.channel || res.channelName || "call",
          token: res.token
        }));
        setIsCallActive(true); // Mark the call as active
        setIncomingCall(null);
        return true; // Indicate success
      } else {
        console.error("Failed to fetch Agora token");
        return false;
      }
    } catch (error) {
      console.error("Error fetching Agora token:", error);
      return false;
    }
  };


  const modeCheck = (details) => {
    let var1 = details?.channel.split("-");
    let var2 = var1[0].split("_")[1];
    setType(var2)
  }

  const handleCloseVideoChat = () => {
    setIsCallActive(false);
  };

  const handleAccept = () => {
    if (incomingCall) {
      // Set the Agora config for the call
      getAgoraDetails();
      // setCallConfig({
      //   appId: incomingCall.appId,
      //   channelName: incomingCall.channelName,
      //   rtcToken: incomingCall.token,
      //   uid: incomingCall.uid,
      // });
      setIsCallActive(true); // Mark the call as active
      setIncomingCall(null); // Clear the incoming call modal
    }
  };

  const handleReject = () => {
    setIncomingCall(null);
    // You would typically send a rejection signal to the caller here
  };

  const handleEndCall = () => {
    setIsCallActive(false); // End the call
    setCallConfig(null); // Clear the Agora config
  };

  return (
    <IncomingCallContext.Provider value={{ showIncomingCall }}>
      {children}
      {/* Incoming Call Modal */}
      <Modal open={!!incomingCall}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            textAlign: 'center',
          }}
        >
          <Typography variant="h5" component="h2" mb={2}>
            Incoming Call
          </Typography>
          <Typography sx={{ mt: 2 }}>
            From: {incomingCall?.callerName || 'Unknown'}
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center" mt={3}>
            <Button variant="contained" color="success" onClick={handleAccept}>
              Accept
            </Button>
            <Button variant="contained" color="error" onClick={handleReject}>
              Reject
            </Button>
          </Stack>
        </Box>
      </Modal>

      {/* Active Call with AgoraManager */}
      {isCallActive && callConfig && (
       
          type !== "videocall" ? 
          <AudioCall 
          appId={callConfig.appId}
          channel={callConfig.channelName}
          token={callConfig.token}
          uid={sessionStorage.getItem("userId") || 0}
          open={true}
          onClose={handleCloseVideoChat}
          startWithVideoOff={true}
          
          
          />
          
          
          : <VideoCalling
          appId={callConfig.appId}
          channel={callConfig.channelName}
          token={callConfig.token}
          uid={Number(sessionStorage.getItem("userId")) || 0}
          open={true}
          onClose={handleCloseVideoChat}
          startWithVideoOff={true}
          // Determine mode based on your logic
        />
      )}
    
    
   
    </IncomingCallContext.Provider>
  );
};

export const useIncomingCall = () => useContext(IncomingCallContext);